/**
 * Where the Dependencies popover hangs from: the horizontal span of the issue
 * panel, level with the field that opened it.
 *
 * Anchored to the field itself, a left-side popover lands on top of the panel
 * it was opened from — covering the dates and comments it is about. Spanning
 * the panel lets a collision flip land beyond its right edge instead. Every
 * host of the issue detail marks itself with `data-issue-panel`. Without a
 * marked host, the popover falls back to the field.
 */
export const ISSUE_PANEL_HOST = "[data-issue-panel]";

export function panelEdgeRect(trigger: HTMLElement): DOMRect {
  const field = trigger.getBoundingClientRect();
  const host = trigger.closest(ISSUE_PANEL_HOST);
  if (!host) return field;
  const panel = host.getBoundingClientRect();
  return new DOMRect(panel.left, field.top, panel.width, field.height);
}
